/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Inicia a Rota
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 11/04/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.Start = function (
  {
    parentSelector = '#RouteSummary',
    successCallback
  } = {}
) {

    this.modalForm = null;
    this.route = null;
    this.blockOverlaySelector = '.mainContainer';

    this.show = function () {
        this.modalForm.showModalForm();
    };

    this.setRoute = function (route) {
        this.route = route;
    };

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    this.createForm = function () {

        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        const date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {

            const layout = {
                "items": [
                    {
                        "tag": "form",
                        "items": [
                            {
                                "items": [
                                    {
                                        "attributes": {
                                            "class": "monetInlineAlerContainer"
                                        }
                                    },
                                    {
                                        "items": [
                                            {
                                                "attributes": {
                                                    "class": "popup-modal-header"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "h3",
                                                        "html": Monet.I18n.getResourcesByKey('greenmile.route.start.btnsave'),
                                                    },
                                                    {
                                                        "tag": "div",
                                                        "items": [
                                                            {
                                                                "tag": "a",
                                                                "attributes": {
                                                                    "href": "https://greenmile.help.descartesservices.com",
                                                                    "class": "MonetUIHelpLink",
                                                                    "title": "Help"
                                                                },
                                                            }
                                                        ],
                                                        "attributes": {
                                                            "class": "MonetUIHelp"
                                                        },


                                                    }
                                                ]
                                            },
                                            {
                                                "tag": "div",
                                                "attributes": {
                                                    "class": "popup-modal-body"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "label",
                                                        "beforeHtml": Monet.I18n.getResourcesByKey('Greenmile.Route.Start.dateTimeFieldLabel'),
                                                        "attributes": {
                                                            "class": "control-label",
                                                            "for": "startTime"
                                                        }
                                                    },
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "text",
                                                            "id": "startTime",
                                                            "value": date.getCurrentDateAndTime(),
                                                            "name": "startTime",
                                                            "class": "dateTimePicker"
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                "tag": "div",
                                                "attributes": {
                                                    "class": "popup-modal-footer formButtons"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "button",
                                                            "value": Monet.I18n.getResourcesByKey('Greenmile.Route.Start.btnSave'),
                                                            "name": "btn_save_start_stop",
                                                            "id": "btn_save_start_stop",
                                                            "class": "btn",
                                                            "style": "width: 170px"
                                                        }
                                                    },
                                                    {
                                                        "tag": "input",
                                                        "attributes": {
                                                            "type": "button",
                                                            "value": Monet.I18n.getResourcesByKey('Greenmile.Route.Start.btnExit'),
                                                            "name": "btn_exit_start_stop",
                                                            "id": "btn_exit_start_stop",
                                                            "class": "btn secondary",
                                                            "style": "width: 75px"
                                                        }
                                                    }
                                                ],
                                            }
                                        ],
                                    }
                                ]
                            }
                        ],
                        "attributes": {
                            "id": "formStartStopFormTemplate"
                        }
                    }
                ]
            };

            modalContainer.appendChild((new Monet.UI.LayoutGenerator(layout)).render());

            date.setDateTimePicker(`${parentSelector} .dateTimePicker`);

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }


    };

    this.addEventListenners = function () {

        try {

            var that = this;
            var btnSave = document.querySelector("#formStartStopFormTemplate #btn_save_start_stop");
            var btnExit = document.querySelector("#formStartStopFormTemplate #btn_exit_start_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doStart();
            };

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No add event listenner to form.");
            error.console();

        }

    };

    this.doStart = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var that = this;

        if (isValid) {
            this.modalForm.toggleLoadingInModalBtn();
            formDataJson = this.getFormValues();

            if (this.route !== null) {

                const request = new DefaultRequest({
                    url: 'Route/' + this.route.get("id") + '/Start',
                    method: 'post',
                    data: formDataJson,
                    success: function (data) {

                        that.modalForm.closeModalWindow();
                        that.successCallback(data);

                    },
                    error: function (data) {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.errorCallback(data);
                    }
                });
                request.send();

            } else {
                var error = new Monet.Exception.ReturnError(this, "route can't be null");
                error.console();
            }
        }

    };

    this.getFormValues = function () {
        const startTimeField = document.querySelector("#formStartStopFormTemplate .dateTimePicker");
        const formattedDate = Monet.Format.DateTime.parseLocaleToISOString(startTimeField.value);
        return {
            actualStart: formattedDate
        };
    };

    this.successCallback = function () {
      if (parentSelector === '#RouteSummary') {
        const router = new App.Routers.RouteSummaryRoutes();

        Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');
        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, true);
      } else {
        successCallback?.();
      }

    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setInfoType("error");
        monetMessage.setScope("#formStartStopFormTemplate");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

    this.validateForm = function () {

        var isValid = true;
        var startTime = document.getElementById("startTime");
        var error = null;
        var actualStart = this.route.get("actualStart");
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formStartStopFormTemplate';

        var formatToCreate = Monet.I18n.locale.dateFormat + ' ' + Monet.I18n.locale.timeFormat;
        var startTimeTimeMili = null;

        try {

            if (startTime.value.trim() === "") {

                utils.showErrorMessage(scopeMessage, "start_date", "Route.Start.cantStartWhitouDateTime");

                isValid = false;

            } else {

                startTimeTimeMili = Monet.Format.DateTime.parseLocale(startTime.value).getTime();
                if (typeof(actualStart) !== "undefined") {

                    utils.showErrorMessage(scopeMessage, 'already_started', 'Route.Start.cantStartStartedRoute');
                    isValid = false;

                } else {

                    if (startTimeTimeMili >= new Date().getTime()) {

                        utils.showErrorMessage(scopeMessage, 'driver', 'Route.Start.cantDoItTheFuture');
                        isValid = false;

                    }
                }
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.addEventListenners();
        };
    }(this);

    var init = function (scope) {

        return function (scope) {

            const selector = parentSelector;

            const options = {
                width: 280,
                height: 194
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);

};
